import { useMemo } from 'react'
import { ActivityCategory } from '../../../../api/activities/types'
import auth from '../../../../api/auth/hooks'
import { activityEventInputs, activityReminderInputs, activityTaskInputs } from '../../../../common/forms/activities/inputs'
import { activityEventValidaton, activityReminderValidaton, activityTaskValidaton } from '../../../../common/forms/activities/validation'
import { ActivityModalData } from '../types'

export const useActivityFormConfig = (data: ActivityModalData | null) => {
    const { data: currentAgentId } = auth.CurrentAgent.useQuery({ select: (data) => data.id })

    const formConfig = useMemo(() => {
        const categoryId = data?.activityType?.activityCategory?.id

        switch (categoryId) {
            case ActivityCategory.Event:
                return {
                    formikInputs: activityEventInputs(),
                    formikConfig: activityEventValidaton(data, currentAgentId),
                }
            case ActivityCategory.Task:
                return {
                    formikInputs: activityTaskInputs(),
                    formikConfig: activityTaskValidaton(data, currentAgentId),
                }
            case ActivityCategory.Reminder:
                return {
                    formikInputs: activityReminderInputs(),
                    formikConfig: activityReminderValidaton(data, currentAgentId),
                }
            default:
                return {
                    formikInputs: activityEventInputs(),
                    formikConfig: activityEventValidaton(data, currentAgentId),
                }
        }
    }, [data, currentAgentId])

    return formConfig
}
